import { render, staticRenderFns } from "./HeaderSet.vue?vue&type=template&id=0cf5e90e&scoped=true"
import script from "./HeaderSet.vue?vue&type=script&lang=js"
export * from "./HeaderSet.vue?vue&type=script&lang=js"
import style0 from "./HeaderSet.vue?vue&type=style&index=0&id=0cf5e90e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf5e90e",
  null
  
)

export default component.exports